import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/cs';
import 'dayjs/locale/da';
import 'dayjs/locale/nl';
import 'dayjs/locale/fi';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/it';
import 'dayjs/locale/nb';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/es';
import 'dayjs/locale/sv';
import 'dayjs/locale/cy';

// Enable advancedFormat plugin for ordinal dates (1st, 2nd, 3rd, 15th, etc.)
dayjs.extend(advancedFormat);

dayjs.locale('en-gb');

const convertLanguageToDayjsLocale = (language: string | null): string => {
  if(!language) return "en-gb";
  if(language.toLowerCase().includes("zh")) return "zh-cn";
  if(language.toLowerCase().includes("en")) return "en-gb";
  if(language.toLowerCase().includes("cs")) return "cs";
  if(language.toLowerCase().includes("da")) return "da";
  if(language.toLowerCase().includes("nl")) return "nl";
  if(language.toLowerCase().includes("fi")) return "fi";
  if(language.toLowerCase().includes("fr")) return "fr";
  if(language.toLowerCase().includes("de")) return "de";
  if(language.toLowerCase().includes("it")) return "it";
  if(language.toLowerCase().includes("nb")) return "nb";
  if(language.toLowerCase().includes("pl")) return "pl";
  if(language.toLowerCase().includes("pt")) return "pt";
  if(language.toLowerCase().includes("es")) return "es";
  if(language.toLowerCase().includes("sv")) return "sv";
  if(language.toLowerCase().includes("cy")) return "cy";
  return "en-gb";
}

export const changeLanguageDate = (language: string | null = 'en'): void => {
  dayjs.locale(convertLanguageToDayjsLocale(language));
};

export default dayjs;